




















































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Mutation, Getter } from 'vuex-class';
import { IcurrentLanguage, ISearchType, ApiAuth, IFilter } from '@/store/types/IRootState';
import CheckedFiltersComponent from '@/components/filterComponents/CheckedFiltersComponent.vue';
import ImageComponent from '@/components/ImageComponent.vue';
import SelectComponent from '@/components/common/SelectComponent.vue';

interface CheckboxOption {
    name: string;
    checked: boolean;
}
@Component({
    components: {
        ImageComponent,
        CheckedFiltersComponent,
        SelectComponent,
    },
})
export default class SearchField extends Vue {
    public searchString: string = '';
    public validLanguages: string[] = ['pt', 'en', 'es'];
    public checkboxOptions: CheckboxOption[] = [
        { name: 'Exibir somente itens', checked: false },
    ];
    public imgurl = '@/assets/pt.svg';
    public created() {
        this.setActiveLanguages();
    }
    // getters
    @Getter
    public getAllLanguages!: IcurrentLanguage[];
    @Getter
    public getGlobalLanguage!: string;
    @Getter
    public getSelectedSearchFieldOption!: string;
    @Getter
    public getCheckedFilters!: IFilter[];
    @Getter
    private userProjectName!: string;

    // mutations
    @Mutation
    private toggleLanguage: any;
    @Mutation
    private setActiveLanguages: any;
    @Mutation
    private setSearchString: any;
    @Mutation
    public setSelectedSearchFieldOption: any;
    @Mutation
    public toggleOnlyClientItems: any;
    @Mutation
    private uncheckCheckedFilters!: () => void;

    // actions
    @Action
    private fetchItems: any;

    @State
    public searchTypes!: ISearchType;
    @State
    private selectedSearchFieldOption!: ISearchType;

    get searchTypeId() {
        return this.selectedSearchFieldOption.id;
    }

    set searchTypeId(value) {
        this.setSelectedSearchFieldOption(value);
    }

    public resetFilters() {
        this.uncheckCheckedFilters();
        this.fetchItems({ generateFilters: true });
    }

    public searchItems(Search: string) {
        this.setSearchString(Search);
        const Language = this.getGlobalLanguage;
        this.fetchItems({ Search, Language, searchSize: 300, generateFilters: true, preserveNameFilters: false });
    }
}
